import { render } from "./AbtestResultItem.vue?vue&type=template&id=4f5e5c1e"
import script from "./AbtestResultItem.vue?vue&type=script&lang=js"
export * from "./AbtestResultItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__